export default {
  SET_NAVIGATION_STATE({ commit }, payload) {
    localStorage.setItem("navigation-state", payload.isOpen);
    commit("SET_NAVIGATION_STATE", payload);
  },
};
